import { render } from "./StatsTab.vue?vue&type=template&id=f870618a&scoped=true"
import script from "./StatsTab.vue?vue&type=script&lang=js"
export * from "./StatsTab.vue?vue&type=script&lang=js"

import "./StatsTab.vue?vue&type=style&index=0&id=f870618a&lang=scss&scoped=true"

import exportComponent from "/root/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f870618a"]])

export default __exports__